import { render, staticRenderFns } from "./socialsignin.vue?vue&type=template&id=5d58b9c4&scoped=true"
import script from "./socialsignin.vue?vue&type=script&lang=js"
export * from "./socialsignin.vue?vue&type=script&lang=js"
import style0 from "./socialsignin.vue?vue&type=style&index=0&id=5d58b9c4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58b9c4",
  null
  
)

export default component.exports